export const getDataManagementAreasContent = (t: any) => [
  {
    key: 'REPORT99',
    title: t('STEPS.REPORT99'),
    infoText: '',
    href: '/data_management/report99',
  },
];
